const info = [
    {
        $schema: '../ibc_data.schema.json',
        chain_1: {
            chain_name: 'axelar',
            client_id: '07-tendermint-230',
            connection_id: 'connection-221'
        },
        chain_2: {
            chain_name: 'xion',
            client_id: '07-tendermint-3',
            connection_id: 'connection-3'
        },
        channels: [{
                chain_1: {
                    channel_id: 'channel-161',
                    port_id: 'transfer'
                },
                chain_2: {
                    channel_id: 'channel-3',
                    port_id: 'transfer'
                },
                ordering: 'unordered',
                version: 'ics20-1',
                tags: {
                    status: 'live',
                    preferred: true
                }
            }]
    },
    {
        $schema: '../ibc_data.schema.json',
        chain_1: {
            chain_name: 'injective',
            client_id: '07-tendermint-279',
            connection_id: 'connection-282'
        },
        chain_2: {
            chain_name: 'xion',
            client_id: '07-tendermint-4',
            connection_id: 'connection-4'
        },
        channels: [{
                chain_1: {
                    channel_id: 'channel-387',
                    port_id: 'transfer'
                },
                chain_2: {
                    channel_id: 'channel-4',
                    port_id: 'transfer'
                },
                ordering: 'unordered',
                version: 'ics20-1',
                tags: {
                    status: 'live',
                    preferred: true
                }
            }]
    },
    {
        $schema: '../ibc_data.schema.json',
        chain_1: {
            chain_name: 'noble',
            client_id: '07-tendermint-128',
            connection_id: 'connection-124'
        },
        chain_2: {
            chain_name: 'xion',
            client_id: '07-tendermint-2',
            connection_id: 'connection-2'
        },
        channels: [{
                chain_1: {
                    channel_id: 'channel-113',
                    port_id: 'transfer'
                },
                chain_2: {
                    channel_id: 'channel-2',
                    port_id: 'transfer'
                },
                ordering: 'unordered',
                version: 'ics20-1',
                tags: {
                    status: 'live',
                    preferred: true
                }
            }]
    },
    {
        $schema: '../ibc_data.schema.json',
        chain_1: {
            chain_name: 'osmosis',
            client_id: '07-tendermint-3366',
            connection_id: 'connection-2823'
        },
        chain_2: {
            chain_name: 'xion',
            client_id: '07-tendermint-1',
            connection_id: 'connection-1'
        },
        channels: [{
                chain_1: {
                    channel_id: 'channel-89321',
                    port_id: 'transfer'
                },
                chain_2: {
                    channel_id: 'channel-1',
                    port_id: 'transfer'
                },
                ordering: 'unordered',
                version: 'ics20-1',
                tags: {
                    status: 'live',
                    preferred: true
                }
            }]
    }
];
export default info;
